import {useEffect, useState} from 'react';

/** Текущее время, обновляемое раз в минуту; до монтирования undefined, чтобы серверная разметка не расходилась с клиентской */
export function useNow(interval = 60 * 1000): number | undefined {
	const [now, setNow] = useState<number>();

	useEffect(() => {
		setNow(Date.now());
		const timer = setInterval(() => setNow(Date.now()), interval);
		return () => clearInterval(timer);
	}, [interval]);

	return now;
}
